import { NavLink } from "react-router-dom";
import React, { useRef } from "react";
import emailjs from "@emailjs/browser";



const Contact = () => {

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm(
      'service_zcrn1im',     // Replace with your actual Service ID
      'template_0ull3ca',    // Replace with your actual Template ID
      form.current,
      '5SKkv1LQbhAaEdH1L'      // Replace with your actual Public Key
    ).then(
      () => {
        alert("Message sent successfully!");
        form.current.reset();
      },
      (error) => {
        console.error("EmailJS Error:", error);
        alert("Failed to send message. Please try again.");
      }
    );
  };


return (
<div>
  <section className="px-6 py-12 md:px-24 md:py-24">
  <h2 className="text-3xl font-bold text-gray-800 mb-10 text-center md:text-left">
    Contact Us
  </h2>

  <div className="flex flex-col md:flex-row items-start gap-6">
    {/* Left image */}
    <img
      src="/images/ContactUs1.jpg"
      alt="Contact"
      className="w-full md:w-1/2 rounded-xl object-cover h-auto"
    />

    {/* Right image with scrolling text overlay */}
    <div className="relative w-full md:w-1/2 rounded-xl overflow-hidden h-64 md:h-auto">
      <img
        src="/images/ContactUs2.jpg"
        alt="Contact Info"
        className="w-full h-full object-cover"
      />

      {/* Scrolling text overlay */}
      <div className="absolute inset-0 flex items-center justify-center p-6">
        <div className="animate-marquee whitespace-normal text-white font-semibold text-sm sm:text-base md:text-lg">
          <h4 className="font-bold mb-2">We’d love to hear from you!</h4>
          <p>
            ABHA Care Pty Ltd is dedicated to providing you with the best
            support and information. Whether you have questions about our
            services, need help with your NDIS plan, or want to chat with our
            team, we’re here to assist you.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>

<section className="px-6 py-12 max-w-7xl mx-auto">
  <h2 className="text-3xl md:text-4xl font-bold text-gray-800 ml-0 mb-4 text-center md:text-left">
    How to Reach Us
  </h2>
  <p className="text-gray-600 mb-10 text-center md:text-left text-base">
    There are several ways to get in touch with our friendly team. We’re always
    ready to assist you with whatever you need.
  </p>

  <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
    {/* Phone */}
    <div className="flex items-start gap-4">
     <svg
  xmlns="http://www.w3.org/2000/svg"
  className="h-8 w-8 text-gray-600 flex-shrink-0"
  fill="none"
  viewBox="0 0 24 24"
  stroke="currentColor"
>
  <path
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth={2}
    d="M3 5a2 2 0 012-2h3.28a2 2 0 011.789 1.106l1.117 2.234a2 2 0 01-.45 2.316l-1.516 1.516a11.05 11.05 0 005.272 5.272l1.516-1.516a2 2 0 012.316-.45l2.234 1.117A2 2 0 0121 17.72V21a2 2 0 01-2 2h-.28C8.72 23 1 15.28 1 6.28V6a2 2 0 012-1z"
  />
</svg>
      <div>
        <h3 className="font-semibold text-gray-800">Phone</h3>
        <p className="text-gray-600 text-sm mt-1">
          You can reach us at <strong>1300 157 211</strong>
          <br />
          If we’re unable to take your call, please leave a message, and we’ll
          get back to you as soon as we can.
        </p>
      </div>
    </div>

    {/* Email */}
    <div className="flex items-start gap-4">
     <svg
  xmlns="http://www.w3.org/2000/svg"
  className="h-8 w-8 text-gray-600 flex-shrink-0"
  fill="none"
  viewBox="0 0 24 24"
  stroke="currentColor"
>
  <path
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth={2}
    d="M4 4h16v16H4V4zm0 0l8 8 8-8"
  />
</svg>
      <div>
        <h3 className="font-semibold text-gray-800">Email</h3>
        <p className="text-gray-600 text-sm mt-1">
          Feel free to drop us a line at{" "}
          <a
            href="mailto:info@abhacare.com.au"
            className="text-blue-600 underline"
          >
            info@abhacare.com.au
          </a>
          .
          <br />
          We aim to respond to all inquiries as promptly as possible.
        </p>
      </div>
    </div>

    {/* Mailing Address */}
    <div className="flex items-start gap-4">
     <svg
  xmlns="http://www.w3.org/2000/svg"
  className="h-8 w-8 text-gray-600 flex-shrink-0"
  fill="none"
  viewBox="0 0 24 24"
  stroke="currentColor"
>
  <path
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth={2}
    d="M12 11a4 4 0 100-8 4 4 0 000 8zm0 0c-4.418 0-8 3.582-8 8 0 2.21 1.79 4 4 4h8c2.21 0 4-1.79 4-4 0-4.418-3.582-8-8-8z"
  />
</svg>
      <div>
        <h3 className="font-semibold text-gray-800">Mailing Address</h3>
        <p className="text-gray-600 text-sm mt-1">
          You can also mail us using the address:
          <br />
          <strong>Abha Care Pty Ltd</strong>
          <br />
          Address,
          <br />
          Suburb, NSW Postcode
        </p>
      </div>
    </div>
  </div>
</section>


 {/*Enquiry form */}
    <section className="px-6 py-12 max-w-7xl mx-auto">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
        {/* Form Section */}
        <div>
          <h2 className="text-4xl font-bold text-gray-800 mb-2">Online Enquiry Form</h2>
          <p className="text-gray-600 mb-8">
            We’d love to hear from you! ABHA Care Pty Ltd is dedicated to providing you with the best support and information.
            Whether you have questions about our services, need help with your NDIS plan, or want to chat with our team, we're here to assist you.
          </p>

          <form ref={form} onSubmit={sendEmail} className="space-y-6">
            {/* Name */}
            <div>
              <label htmlFor="name" className="block font-semibold text-green-900 mb-1">
                Your Name <span className="text-red-600">*</span>
              </label>
              <input
                type="text"
                name="name"
                required
                className="w-full border border-green-700 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
              />
            </div>

            {/* Email */}
            <div>
              <label htmlFor="email" className="block font-semibold text-green-900 mb-1">
                Email <span className="text-red-600">*</span>
              </label>
              <input
                type="email"
                name="email"
                required
                className="w-full border border-green-700 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
              />
            </div>

            {/* Phone */}
            <div>
              <label htmlFor="phone" className="block font-semibold text-green-900 mb-1">
                Phone Number <span className="text-red-600">*</span>
              </label>
              <input
                type="tel"
                name="phone"
                required
                className="w-full border border-green-700 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
              />
            </div>

            {/* Message */}
            <div>
              <label htmlFor="message" className="block font-semibold text-green-900 mb-1">
                Message <span className="text-red-600">*</span>
              </label>
              <textarea
                name="message"
                required
                rows="6"
                className="w-full border border-green-700 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
              />
            </div>

            {/* Submit Button */}
            <div>
              <button
                type="submit"
                className="bg-green-700 hover:bg-green-800 text-white font-semibold px-8 py-2 rounded-full transition"
              >
                Submit
              </button>
            </div>
          </form>
        </div>

        {/* Contact Info Section */}
       {/* <div>
          <h2 className="text-3xl font-bold text-gray-800 mb-4">How to Contact Us</h2>
          <div className="text-gray-700 space-y-2">
            <p>
              <strong>Location:</strong><br />
              Abha Care Pty Ltd<br />
              Address,<br />
              Suburb, NSW Postcode
            </p>

            <p>
              <strong>Hours</strong><br />
              Monday to Friday: 9:00 AM - 5:00 PM<br />
              Saturday & Sunday: Closed
            </p>

            <p>
              <strong>Contact</strong><br />
              <span className="text-green-700 font-medium">Phone No.</span><br />
              <span className="text-green-700 font-medium">Phone No.</span><br />
              <a href="mailto:info@abhacare.com.au" className="text-green-600 hover:underline">
                info@abha-care.com.au
              </a>
            </p>
          </div>
        </div> */}
      </div>
      <div className="mt-20">
         <h2 className="text-4xl font-bold text-gray-800 mb-2">Feel Free to Contact Us </h2>
          <p className="text-gray-600 mb-8">
            We look forward to hearing from you and exploring how we can support you on 
            your journey. At Abha Care, we’re here to help you achieve your goals and live a fulfilling life.  </p>
      </div>
    </section>

    {/*Info Section */}
              <section className="bg-[#3f4f2b] text-white py-20">
                <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-4 gap-10 text-sm">
                  {/* Logo + Location */}
                  <div className="flex flex-col items-center md:items-start text-center md:text-left space-y-4">
                    <img src="/images/Logo-inverted.svg" alt="ABHA CARE Logo" className="h-16 mx-auto md:mx-0" />
                    <p className="font-semibold">New South Wales, Australia</p>
                  </div>
              
                  {/* Site Links */}
                  <div>
                    <h4 className="font-bold mb-4 text-lg">Site</h4>
                    <ul className="space-y-2 text-lg">
                      <li><NavLink to="/" className="hover:underline">Home</NavLink></li>
                      <li><NavLink to="/about" className="hover:underline">About Us</NavLink></li>
                      <li><NavLink to="/services" className="hover:underline">Services</NavLink></li>
                      <li><NavLink to="/faq" className="hover:underline">FAQ</NavLink></li>
                      <li><NavLink to="/contact" className="hover:underline">Contact Us</NavLink></li>
                    </ul>
                  </div>
              
                  {/* Location + Hours */}
                  <div>
                    <h4 className="font-bold mb-4 text-lg">Location</h4>
                    <p className="text-lg">Abha Care Pty Ltd<br />
                    <br />
                    </p>
              
                    <h4 className="font-bold mt-6 mb-2 text-lg"> OfficeHours</h4>
                    <p className="text-lg">
                      Monday - Friday: 9:00AM - 5:00PM<br />
                      Saturday & Sunday: Closed</p>
                  </div>
              
                  {/* Contact Info */}
                  <div>
                    <h4 className="font-bold mb-4 text-lg">Contact</h4>
                    <p className="text-lg">Phone: 02 8395 2893<br /></p>
                    <p className="text-lg  ml-14">1300 157 211<br /></p>
                    <p className="mt-2 text-lg">
                      <a href="mailto:info@abhacare.com.au" className="hover:underline text-lg">
                        info@abhacare.com.au
                      </a>
                    </p>
                  </div>
                </div>
              </section>
    </div>
  );
};

export default Contact;
